import { render, staticRenderFns } from "./VgBadNeustadtOutdoorMonitor.vue?vue&type=template&id=f1c396bc&scoped=true&"
import script from "./VgBadNeustadtOutdoorMonitor.vue?vue&type=script&lang=js&"
export * from "./VgBadNeustadtOutdoorMonitor.vue?vue&type=script&lang=js&"
import style0 from "./VgBadNeustadtOutdoorMonitor.vue?vue&type=style&index=0&id=f1c396bc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1c396bc",
  null
  
)

export default component.exports